import { useClipboard } from '@chakra-ui/react'

import { CheckIcon, CopyIcon } from '../icon'
import { IconButton } from './icon-button'

type Props = {
  value: string
}

export const Clipboard = (props: Props) => {
  const { copied, copy } = useClipboard({ value: props.value })
  return (
    <IconButton
      variant="ghost"
      size="xs"
      colorPalette={copied ? 'green' : 'gray'}
      onClick={copy}
    >
      {copied ? <CheckIcon /> : <CopyIcon />}
    </IconButton>
  )
}
